export default "__VITE_ASSET__GenEPIYA__"